import {
  AloftPrice,
  expected,
  isDefined,
  schAlertType,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';
import { getCompTypeLabel, getScopedAlertType } from '../utils/compTypeScoping.ts';

const THRESHOLD_RATIO = 0.25;

export const limitedAdjustedSalePriceRange: AlertDefinition = ({
  compAdjustments,
  compSequence,
  compType,
  order,
}) => {
  const compAdjustedSalePrices = compSequence
    .map((id) => compAdjustments[id]?.adjustedSalePrice.adjustment)
    .filter(isDefined);

  if (compAdjustedSalePrices.length < 2) return undefined;

  const maxAdjustedSalePrice = expected(AloftPrice.max(compAdjustedSalePrices));
  const minAdjustedSalePrice = expected(AloftPrice.min(compAdjustedSalePrices));

  if (
    maxAdjustedSalePrice.sub(minAdjustedSalePrice).ratio(minAdjustedSalePrice) <= THRESHOLD_RATIO
  ) {
    return undefined;
  }

  let message: string;
  switch (compType) {
    case 'aiv':
    case 'arv':
      message = `Adjusted sales price range between ${getCompTypeLabel(compType)} Comparables is greater than 25%.`;
      break;
    default:
      message = 'Adjusted sales price range between all Comparable is greater than 25%.';
      break;
  }

  const fixRoute =
    schPairedCostRouteItem.enum[order.isInspectifyOrder ? 'adjustments-grid' : 'adjustments'];

  return {
    type: getScopedAlertType(schAlertType.enum.limitedAdjustedSalePriceRange, compType),
    status: 'active',
    severity: 'error',
    orderType: ['saas', 'appraisify'],
    message,
    ...(compType ? { compType } : {}),
    fixingInfo: {
      tips: 'Tips: Adjusted sale prices should cluster tightly (within 5-10%) to demonstrate that the comparables are genuinely similar and the analysis is sound.',
      pairedCostRouteItem: fixRoute,
      fixingMethod: ['comment', 'action'],
      commentAlwaysRequired: false,
    },
    triggers: getAlertTriggers({
      fixRoute,
      order,
      includeUpdate: true,
    }),
  };
};
